"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardLink = exports.Description = exports.Wrapper = exports.CardHeading = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../../typography");
var theme_1 = require("../../../theme");
var typography_2 = require("../../typography");
var Link_1 = __importDefault(require("../../navigation/Link"));
var BACKGROUND_COLOR = {
    blue: 'PALE_BLUE_40',
    pink: 'PINK_30',
    yellow: 'YELLOW_20',
    green: 'GREEN_20',
};
exports.CardHeading = (0, styled_components_1.default)(typography_2.Heading)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  background-color: ", ";\n  padding: 24px;\n  position: relative;\n\n  @media ", " {\n    padding: 32px;\n  }\n\n  ", " {\n    &:hover ", " {\n      color: ", ";\n    }\n  }\n"], ["\n  display: block;\n  background-color: ", ";\n  padding: 24px;\n  position: relative;\n\n  @media ", " {\n    padding: 32px;\n  }\n\n  ", " {\n    &:hover ", " {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return theme_1.theme.colors[BACKGROUND_COLOR[$backgroundColor]];
}, theme_1.theme.breakpoints.large, theme_1.theme.utils.canHover, exports.CardHeading, function (_a) {
    var $hoverColor = _a.$hoverColor;
    return $hoverColor && theme_1.theme.colors[$hoverColor];
});
exports.Description = (0, styled_components_1.default)(typography_1.Body)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n\n  @media ", " {\n    display: block;\n  }\n"])), theme_1.theme.breakpoints.medium);
exports.CardLink = (0, styled_components_1.default)(Link_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin-bottom: 0 !important;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin-bottom: 0 !important;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
